/**
 * Author: BaiJiFeiLong@gmail.com
 * Datetime: 2017/5/15 下午9:40
 */
let apiBaseUrl = '';
if (process.env.NODE_ENV === 'production'){
    apiBaseUrl = `https://api.aimusics.immusician.com/v3`
}else{
    apiBaseUrl = `https://api.aimusics.immusician.com/v3`
    // apiBaseUrl =`http://192.168.2.171:22222/v3`
   //  apiBaseUrl =`http://192.168.2.70:22222/v3` //晓坡
}
export default {
    apiNewBaseUrl: 'https://stats.ai.api.immusician.com/v3',
    apiBaseUrl,
    //uploadUrl: 'http://up-z0.qiniu.com/',
    uploadUrl: 'https://up.qiniup.com/',
    downloadBaseUrl: 'http://iguitar-new.iguitar.immusician.com',

};



// WEBPACK FOOTER //
// src/config/index.js